module.exports = __webpack_public_path__ + "static/img/tshirt_r.33a36874.webp";